
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.1298 14.56L14.5598 13.13L20.2898 18.86C20.6798 19.25 20.6798 19.89 20.2898 20.29C19.8998 20.68 19.2598 20.68 18.8598 20.29L13.1298 14.56ZM17.4198 8.83L18.6898 7.56C19.5798 6.67 19.4598 5.13 18.3798 4.48C14.4898 2.1 9.34981 2.59 5.97981 5.95C9.90981 4.65 14.2898 5.7 17.4198 8.83ZM5.94981 5.98C2.58981 9.35 2.09981 14.49 4.46981 18.38C5.12981 19.46 6.65981 19.59 7.54981 18.69L8.81981 17.42C5.69981 14.29 4.64981 9.91 5.94981 5.98ZM5.96981 5.96L5.95981 5.97C5.57981 8.98 7.12981 12.85 10.2598 15.99L15.9898 10.26C12.8598 7.13 8.97981 5.58 5.96981 5.96Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-beach-access`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBeachAccess

    ```js
    <b-new-b-icon-beach-access />
    ```
</docs>


